module.exports = __webpack_public_path__ + "static/img/1.2dff2d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/zsw/1.jpg
// module id = pGDZ
// module chunks = 1